// @flow
import type { Action } from '../../reducers';

export default function createAction<T>(type: string): (data: T) => Action<T> {
  return data => ({
    type,
    data
  });
}



// WEBPACK FOOTER //
// ./src/actions/utils/createAction.js